import type { PropertyFeatureConfig } from '../../../types/insurances/PropertyFeatureConfig';

export const property: PropertyFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
            showPackage: false,
            showContractHolder: true,
            showContractNumber: true,
            fallbackAssistancePhonesKey: 'RO_PROPERTY',
            fallbackAssistanceEmailsKey: 'RO_PROPERTY',
        },
        propertySubjects: {
            showSimplifiedAddress: false,
        },
        showLinkedLoans: true,
    },
    history: {
        visible: false,
    },
    settings: {
        details: {
            showStatus: true,
        },
    },
};
